module.exports = __webpack_public_path__ + "static/media/lens.6412c7b8.jpg";